export default {
	pageName: "CreateWorkflowTemplate",
	pageWrapperSpacing: 20,
	todosMaxCount: 50,
	workflowNameMaxCharacters: 250,
	todoNameMaxCharacters: 250,
};
